import React from 'react';
import type { WorkspaceMember } from '@sahaj/types';
import { UserAvatar } from '../common/UserAvatar';

interface MentionAutocompleteProps {
  query: string;
  members: WorkspaceMember[];
  onSelect: (member: WorkspaceMember) => void;
  onClose: () => void;
  selectedIndex: number;
}

export const MentionAutocomplete: React.FC<MentionAutocompleteProps> = ({
  query,
  members,
  onSelect,
  selectedIndex,
}) => {
  const filtered = members
    .filter((m) =>
      m.user.displayName.toLowerCase().includes(query.toLowerCase())
    )
    .slice(0, 8);

  if (filtered.length === 0) return null;

  return (
    <div className="absolute left-3 bottom-full mb-2 w-64 max-h-56 overflow-y-auto bg-card/95 backdrop-blur-md border border-border rounded-xl shadow-2xl z-50 p-1.5 flex flex-col gap-0.5">
      <div className="px-2 py-1 text-[11px] font-semibold tracking-wider text-muted-foreground uppercase">
        Mention Member
      </div>
      {filtered.map((m, idx) => {
        const isSelected = idx === selectedIndex;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onSelect(m)}
            className={`w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg text-left text-sm transition-colors ${
              isSelected ? 'bg-primary text-primary-foreground' : 'hover:bg-muted text-foreground'
            }`}
          >
            <UserAvatar
              userId={m.user.id}
              displayName={m.user.displayName}
              avatarUrl={m.user.avatarUrl}
              size="xs"
              className="shrink-0 shadow-2xs"
            />
            <div className="flex flex-col min-w-0">
              <span className="font-medium truncate leading-tight">{m.user.displayName}</span>
              <span className={`text-[10px] ${isSelected ? 'text-primary-foreground/80' : 'text-muted-foreground'}`}>
                {m.role.toLowerCase()}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};
